import React from 'react';
import { Link } from 'react-router-dom';
import formatTableDate from '../../../lib/helpers/GeneralHelpers/formatTableDate';
import getUsersFullName from '../../../lib/helpers/GeneralHelpers/getUsersFullName';
import Body from 'components/text/Body';

const columns = [
  {
    title: '_id',
    dataIndex: '_id',
    key: '_id',
    render: _id => (
      <Link style={{ fontSize: 10 }} to={`/admin/organization/${_id}`}>
        {_id}
      </Link>
    ),
  },
  {
    title: 'Name',
    render: (text, { _id, title }) => <Body>{title}</Body>,
  },
  {
    title: 'Date Started',
    render: (text, { _id, createdAt }) => <Body>{formatTableDate(createdAt)}</Body>,
  },
  {
    title: 'Dashboards',
    render: (text, { numberOfDashboards }) => <Body>{numberOfDashboards}</Body>,
  },
  {
    title: 'Main Contact',
    render: (text, { _id, mainUser }) => {
      if (mainUser && mainUser.profile) {
        return <Body>{getUsersFullName(mainUser)}</Body>;
      }
      return null;
    },
  },
  {
    title: '# Users',
    render: (text, { numberOfUsers }) => <Body>{numberOfUsers}</Body>,
  },
];

export default columns;



// WEBPACK FOOTER //
// ./src/routes/admin-organizations/OrganizationsTable/columns.js